import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Route } from "react-router-dom";

import ExampleIframeComponent from "./pages/Home";

function App() {
  return (
    <Router>
      <div className="App">
        <ExampleIframeComponent />
      </div>
    </Router>
  );
}

export default App;
